export default "__VITE_ASSET__DED51XYl__"